import { get } from 'lodash';
import Service from '../../services';

export const getApartmentDetail = async params => {
  const response = await Service.isnGet(`/api/apartment/details-apartment${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const checkDateActive = async params => {
  const response = await Service.isnGet(`/api/booking/check-apartment${params}`, res => res);
  // const data = get(response, 'data', null);
  return response;
};

export const getTypePayments = async params => {
  const response = await Service.isnGet(`/api/booking/type-payments${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getBankTransfer = async params => {
  const response = await Service.isnGet(`/api/booking/bank-transfer${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const postSubmitBooking = async payload => {
  await Service.setHeaderToken(JSON.parse(localStorage.getItem('authUserData'))?.token?.access_token);
  const response = await Service.isnPost(`/api/booking/submit-booking`, payload, res => res);
  return response;
};

export const getBooking = async params => {
  await Service.setHeaderToken(JSON.parse(localStorage.getItem('authUserData'))?.token?.access_token);
  const response = await Service.isnGet(`/api/booking/get-booking${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const postCancelBooking = async payload => {
  await Service.setHeaderToken(JSON.parse(localStorage.getItem('authUserData'))?.token?.access_token);
  const response = await Service.isnPost(`/api/booking/cancel-booking`, payload, res => res);
  return response;
};
